import { Component, OnInit } from '@angular/core';
import { URLS } from '../../../shared/constant/interface';
import { _HttpClient } from '@delon/theme';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.less'],
})
export class VoiceChannelViewComponent implements OnInit {
  static SCENE = 'icc-msg-channel-view';
  record: any = {};
  constructor(public http: _HttpClient) { }
  provider = null;
  channel: any = {};

  ngOnInit() {
    const urlSel = URLS.searchChannelProvider.url;
    if (this.record.id > 0) {
      this.http.post(urlSel, this.record.msgType).subscribe(res => {
        res.data.forEach(res1 => {
          if (res1.id === this.record.providerId) {
            this.channel.providerName = res1.name;
            this.channel.speed = this.record.speed;
            this.channel.identity = this.record.identity;
            this.channel.channelNum = this.record.channelNum;
            this.channel.name = this.record.name;
            this.channel.appId = this.record.appId;
            this.channel.appKey = this.record.appKey;
            this.channel.appSecret = this.record.appSecret;
            this.channel.templateId = this.record.templateId;
            this.channel.carrier = this.record.carrierId;
            if (this.record.carrierId === 1) {
              this.channel.carrier = '移动';
            } else if (this.record.carrierId === 2) {
              this.channel.carrier = '联通';
            } else if (this.record.carrierId === 3) {
              this.channel.carrier = '电信';
            }
          }
        });
      });
    }
  }
}
